import { CustomTemplatedMessageVariables } from 'generated-graphql/types';

export const fillTemplatedMessage = (
  templatedMessage: string,
  variables: { label: string; value: CustomTemplatedMessageVariables }[]
) => {
  const mappingArray = templatedMessage.match(/\{\{(.*?)\}\}/g);
  if (!mappingArray) return templatedMessage;

  let filledMessage = templatedMessage;

  mappingArray.forEach((match) => {
    const variableKey = match.replace('{{', '').replace('}}', '');
    const variable = variables.find((v) => v.value === variableKey);

    if (variable) {
      filledMessage = filledMessage.replace(
        new RegExp(match, 'g'),
        variable.label || ''
      );
    }
  });

  return filledMessage;
};
